export default {
  // 判断是否可以参与接口
  initInfo: '/gw/generic/jrm/h5/m/initInfo',
  // 摇钱树托底页接口
  myShareInfo: '/gw/generic/jrm/h5/m/myShareInfo',
  // 参与游戏接口(领取奖励/分享弹窗)
  takeReward1: '/gw/generic/jrm/h5/m/takeReward1',
  // 判断是否是新人接口
  isShareRoleInfo: '/gw/generic/jrm/h5/m/isShareRoleInfo',
  // 分享增加参与机会
  addTimes: '/gw/generic/jrm/h5/m/addTimes',
  // 是否已分享或已设置提醒
  isFinishedInfo: '/gw/generic/jrm/h5/m/isFinishedInfo'
}
